import { Spin } from 'antd';
import useGetEligibleStatus from 'hooks/textVisit/useGetEligibleStatus';
import useGetScriptSureOnboardLink from 'hooks/useGetScriptSureOnboardLink';
import useGetScriptSureToken from 'hooks/useGetScriptSureToken';
import React from 'react';
import s from './s.module.less';

type Props = {
    onFinish?: () => void;
};

const ScriptSureOnboarding = (props: Props) => {
    const { onFinish } = props;
    const [link, loadingLink, fetchLink] = useGetScriptSureOnboardLink();
    // const [token, loadingToken, fetchToken] = useGetScriptSureToken();
    const [eligibleStatus, loadingEligibleStatus, fetchEligibleStatus] = useGetEligibleStatus();
    const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

    React.useEffect(() => {
        timeoutRef.current = setInterval(() => {
            fetchEligibleStatus();
        }, 5000);
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    React.useEffect(() => {
        if (eligibleStatus?.completedScriptSureOnboarding) {
            if (timeoutRef.current) {
                clearInterval(timeoutRef.current);
            }
            timeoutRef.current = null;
            onFinish?.();
        }
    }, [eligibleStatus]);

    return (
        <div
            className={s.wrap}
        >
            <div className={s.content}>
                {
                    link ? (
                        <iframe
                            title="script-sure-onboard"
                            src={link}
                            width="100%"
                            height="700px"
                            frameBorder="0"
                        />
                    ) : (
                        <div className={s.loading}>
                            <Spin />
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default ScriptSureOnboarding;
